import {getRandNumMp, intRandom} from './_randNum';
import {hoverDynamic} from './hover';

export function homeGallery() {
  const container = document.getElementById('container');
  const homeGallery = document.querySelector('.js-home-gallery');
  const trigger = document.querySelector('.js-trigger-gallery');
  
  if(homeGallery && postsObj) {
    const obj = postsObj.posts;
    const randoms = [];
    const randomsNum = obj.length-1;
    let current = randomsNum;
    let PassSec = '';
    let PassageID = '';
    let autoPlay = '';

    const counterInit = () => {
      const count = document.querySelector('.js-home-gallery-count');
      document.body.classList.add('is-home-gallery-playing');
      PassSec = 5;
      count.innerHTML = PassSec;
      if(!count) clearInterval(PassageID);
      PassageID = setInterval(() => {
        PassSec--;
        count.innerHTML = PassSec;
      }, 1000);
    }

    const counterClear = () => {
      document.body.classList.remove('is-home-gallery-playing');
      clearInterval(PassageID);
      clearInterval(autoPlay);
    }

    const homeGalleryChange = (isNext = true) => {
      const homeGallery = document.querySelector('.js-home-gallery');
      if(!homeGallery) clearInterval(autoPlay);
      const galleryTitle = document.querySelector('.js-home-gallery-title');
      if(galleryTitle) galleryTitle.remove();
      
      if(isNext) {
        if(current == randomsNum) {
          current = 0;
        } else {
          current++;
        }
      } else {
        if(current == 0) {
          current = randomsNum;
        } else {
          current--;
        }
      }
      const currentNum = randoms[current];
      const currentObj = obj[currentNum];
      const ratio = currentObj.height/currentObj.width*100;

      // image container
      const imgContainer = document.createElement('div');
      imgContainer.classList.add('image-container');
      imgContainer.style.paddingBottom = `${ratio}%`;
      imgContainer.style.transform = `translate(${getRandNumMp(40)}%,${getRandNumMp(40)}%)`;

      // img
      const img = document.createElement('img');
      img.setAttribute('src', currentObj.image);

      // title
      const title = document.createElement('p');
      title.classList.add('home-gallery-title', 'js-home-gallery-title');

      const cats = currentObj.categories;
      if(cats) {
        for(let i = 0; i < cats.length; i++) {
          const cat = cats[i];
          const a = document.createElement('a');
          a.setAttribute('href', cat.link);
          a.innerHTML = `${cat.name} - `;
          a.classList.add('js-home-post-category');
          a.setAttribute('target', '_self');
          title.appendChild(a);
        }
      }

      // link
      const a = document.createElement('a');
      a.classList.add('js-home-post-title');
      a.setAttribute('href', currentObj.permalink);
      a.setAttribute('target', '_self');
      a.innerHTML = `${currentObj.name}`;

      // post
      const el = document.createElement('div');
      el.classList.add('post');
      el.style.width = `${intRandom(40,120)}%`;
      el.style.maxWidth = `${currentObj.width}px`;

      title.appendChild(a);
      imgContainer.appendChild(img);
      el.appendChild(imgContainer);

      homeGallery.innerHTML = '';
      homeGallery.appendChild(el);

      container.appendChild(title);

      hoverDynamic(document.querySelector('.js-home-post-title'))
      hoverDynamic(document.querySelector('.js-home-post-category'))
    }

    const playing = () => {
      clearInterval(PassageID);
      counterInit();
      autoPlay = setInterval(() => {
        clearInterval(PassageID);
        counterInit();
        homeGalleryChange();
      }, 5000);
    };

    homeGallery.addEventListener('click', () => {
      counterClear();
      homeGalleryChange();
      counterInit();
      playing();
    });

    trigger.addEventListener('click', () => {
      if(document.body.classList.contains('is-home-gallery-playing')) {
        counterClear();
        clearInterval(autoPlay);
      } else {
        counterClear();
        playing();
      }
    });

    document.addEventListener('keydown', (e) => {
      if(e.keyCode == 39) { // right key
        counterClear();
        homeGalleryChange();
      }
      if(e.keyCode == 37) { // left key
        counterClear();
        homeGalleryChange(false);
      }
      if(e.keyCode == 32) { // space key
        if(document.body.classList.contains('is-home-gallery-playing')) {
          counterClear();
          clearInterval(autoPlay);
        } else {
          counterClear();
          playing();
        }
      }
    });

    const homeGalleryInit = () => {
      const min = 0;
      const max = obj.length-1;
      for(let i = min; i <= max; i++) {
        while(true) {
          var tmp = intRandom(min, max);
          if(!randoms.includes(tmp)) {
            randoms.push(tmp);
            break;
          }
        }
      }
      counterClear();
      homeGalleryChange();
      counterInit();
      playing();
    }
    
    homeGalleryInit();
  }
}